export default class Suggestions {
    constructor(box21_api) {
        this.api = box21_api;
    }

    async overview() {
        const formData = new FormData();
        formData.append('project_id', sessionStorage.getItem('project_id'));
        return this.api.post_with_token('/suggestions/overview', formData);
    }

    async clear_by_model(model_id) {
        const formData = new FormData();
        formData.append('project_id', sessionStorage.getItem('project_id'));
        if (model_id == null) {
            formData.append('model_id', '');
        } else {
            formData.append('model_id', String(model_id));
        }
        return this.api.post_with_token('/suggestions/clear-by-model', formData);
    }

    async clear_all() {
        const formData = new FormData();
        formData.append('project_id', sessionStorage.getItem('project_id'));
        return this.api.post_with_token('/suggestions/clear-all', formData);
    }
}
